import { createContext } from "react";

import type { Account, MembershipRole, User } from "@/api/types";

export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export interface AuthContextValue {
  status: AuthStatus;
  user: User | null;
  /** Conta ativa da sessão (o tenant). */
  account: Account | null;
  /** Todas as contas às quais o usuário pertence. */
  accounts: Account[];
  role: MembershipRole | null;
  /** owner e admin administram a conta (assinatura, recarga). */
  canManageAccount: boolean;
  login: (input: {
    email: string;
    password: string;
    accountId?: string;
  }) => Promise<void>;
  /**
   * Cadastro. O backend cria usuário, conta, vínculo de owner e carteira em
   * UMA transação e já devolve a sessão — ver `Auth::RegisterAccount`.
   *
   * `accountName` é opcional: o cadastro não exige empresa.
   */
  register: (input: {
    accountName?: string;
    name: string;
    email: string;
    password: string;
    document?: string;
  }) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
